// src/pages/basket/hooks/useBasket.js
import {
  useGetBasketQuery,
  useAddOrUpdateBasketMutation,
  useRemoveFromBasketMutation,
  useClearBasketMutation,
  useUpdateProductQuantityInBasketMutation,
  useConvertBasketToOrderMutation,
  useLazyGetConvertPrefillQuery,
  useUpdateDeliveryDateMutation,
} from "../../../api/endpoints/basket";

export const useBasket = () => {
  const { data, isLoading, isError, refetch } = useGetBasketQuery();

  const [addOrUpdate] = useAddOrUpdateBasketMutation();

  const [removeItem, { isLoading: isRemoving }] =
    useRemoveFromBasketMutation();

  const [clear, { isLoading: isClearing }] =
    useClearBasketMutation();

  const [updateQuantityMutation, { isLoading: isUpdatingQuantity }] =
    useUpdateProductQuantityInBasketMutation();

  const [convertToOrder, { isLoading: isConverting }] =
    useConvertBasketToOrderMutation();

  const [triggerPrefillRaw, { data: prefill, isFetching: isPrefilling }] = useLazyGetConvertPrefillQuery();

  const triggerPrefill = (languageId) => triggerPrefillRaw({ languageId });

  const [updateDeliveryDateMutation, { isLoading: isUpdatingDeliveryDate }] =
    useUpdateDeliveryDateMutation();

  const updateQuantity = async ({ itemCode, quantity }) =>
    await updateQuantityMutation({ itemCode, quantity }).unwrap();

  const updateDeliveryDate = async ({ basketLineId, deliveryDate }) =>
    await updateDeliveryDateMutation({ basketLineId, deliveryDate }).unwrap();

  return {
    basket: data?.data,
    isLoading,
    isError,
    refetch,
    addOrUpdate,
    removeItem,
    clear,
    updateQuantity,
    updateDeliveryDate,
    convertToOrder,
    triggerPrefill,
    prefill,
    isPrefilling,
    isUpdatingQuantity,
    isUpdatingDeliveryDate,
    isRemoving,
    isClearing,
    isConverting,
  };
};
